import React from 'react';
import { AlertTriangleIcon, CheckCircle2Icon, PhoneCallIcon, UsersIcon } from 'lucide-react';
import { Card } from '../ui/Card';
import { ProgressBar } from '../ui/ProgressBar';
interface DailyProgressProps {
  remaining: number;
  workedToday: number;
  callsCompleted: number;
  overdueActivities: number;
  total: number;
}
const iconWrap = 'flex h-9 w-9 items-center justify-center rounded-lg';
export function DailyProgress({
  remaining,
  workedToday,
  callsCompleted,
  overdueActivities,
  total
}: DailyProgressProps) {
  const stats = [{
    label: 'Leads Remaining',
    value: remaining,
    icon: <UsersIcon className="h-4 w-4 text-brand-700" aria-hidden="true" data-id="element-157" data-mp="1xbj2y3xegpex" />,
    wrap: 'bg-brand-50'
  }, {
    label: 'Leads Worked Today',
    value: workedToday,
    icon: <CheckCircle2Icon className="h-4 w-4 text-emerald-700" aria-hidden="true" data-id="element-158" data-mp="38p3nyiwbezi3" />,
    wrap: 'bg-emerald-50'
  }, {
    label: 'Calls Completed',
    value: callsCompleted,
    icon: <PhoneCallIcon className="h-4 w-4 text-ink-600" aria-hidden="true" data-id="element-159" data-mp="3u95jzdbql9qa" />,
    wrap: 'bg-ink-100'
  }, {
    label: 'Overdue Activities',
    value: overdueActivities,
    icon: <AlertTriangleIcon className="h-4 w-4 text-amber-700" aria-hidden="true" data-id="element-160" data-mp="7466lh61ik4i" />,
    wrap: 'bg-amber-50'
  }];
  const pct = total > 0 ? Math.round(workedToday / total * 100) : 0;
  return <Card className="p-5" data-id="element-161" data-mp="3al6bk94naeo1">
      <div className="grid grid-cols-2 gap-5 lg:grid-cols-4" data-id="element-162" data-mp="3alo713jhgouw">
        {stats.map(stat => <div key={stat.label} className="flex items-center gap-3" data-id="element-163" data-mp="3fj7w6yhpym1m">
            <div className={`${iconWrap} ${stat.wrap}`} data-id="element-164" data-mp="3kj2lwyprd5l3">{stat.icon}</div>
            <div data-id="element-165" data-mp="3kgzkzjn2hs1l">
              <p className="tabular text-2xl font-semibold tracking-tight text-ink-900" data-id="element-166" data-mp="3p9soy5apowcm">
                {stat.value}
              </p>
              <p className="text-xs font-medium text-ink-500" data-id="element-167" data-mp="2rv6nnpkjj5m7">{stat.label}</p>
            </div>
          </div>)}
      </div>

      <div className="mt-5 border-t border-ink-200 pt-4" data-id="element-168" data-mp="2wrneirj4jy2z">
        <div className="mb-2 flex items-center justify-between text-xs font-medium" data-id="element-169" data-mp="2os0lmr01janj">
          <span className="text-ink-500" data-id="element-170" data-mp="2krgrzxeoep65">Today&apos;s queue progress</span>
          <span className="tabular text-ink-700" data-id="element-171" data-mp="2kpdzn6q1wjy9">
            {workedToday} of {total} · {pct}%
          </span>
        </div>
        <ProgressBar value={workedToday} max={total} label="Today's queue progress" data-id="element-172" data-mp="2tj0hru1c5ooz" />
      </div>
    </Card>;
}